const locale = require('./modificationDetail.i18n.json');

/*@ngInject*/
const ModificationDetailController = function ($scope, $stateParams, currentSubmissionModel, submissionMediator, submissionActionUtil, submissionConstant, formViewerConstant, formMediator) {

    $scope.i18n = locale;

    $scope.viewModel = {
        submission: null,
        showModificationDetail: false,
        currentFormData: null
    };

    function loadModifications(submission) {
        if (submission.changeSetId) {
            submissionMediator.loadChangeSet(submission.changeSetId, true).then(onChangeSetLoaded);
            $scope.viewModel.showModificationDetails = true;
        } else {
            $scope.viewModel.showModificationDetails = false;
        }

        function onChangeSetLoaded(changeSet) {
            if (changeSet.endTime) {
                $scope.viewModel.modificationStatusText = _.get($scope.i18n, 'modificationsSubmitted');
            } else {
                $scope.viewModel.modificationStatusText = _.get($scope.i18n, 'modificationsInProgress');
            }
        }
    }

    $scope.onOpenRecentChanges = function () {
        const submission = submissionMediator.getCurrentSubmission();
        submissionActionUtil.handleReviewModifications(submission);
    };

    $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (e, formData) {
        $scope.viewModel.currentFormData = formData;
        loadModifications(submissionMediator.getCurrentSubmission());
    });

    $scope.shouldShowModificationDetails = function () {
        if (_.isNil($scope.viewModel.currentFormData) || !$scope.viewModel.currentFormData.uiFormTemplate) {
            return false;
        }

        return $scope.viewModel.showModificationDetails;
    };

    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
        loadModifications(submission);
    });

    loadModifications(submissionMediator.getCurrentSubmission());

    $scope.viewModel.currentFormData = formMediator.getFormStructure(parseInt($stateParams.formId));
};

angular.module('gw-um-submission')
    .controller('modificationDetailController', ModificationDetailController);
